import { jsxs as m, jsx as o } from "react/jsx-runtime";
import { useNavigation as l } from "react-day-picker";
import { Wrapper as s, Title as c } from "./styles.js";
import { IconButton as e } from "../../IconButton/IconButton.js";
import { CaretLeft as p } from "../../../foundations/icons/CaretLeft.js";
import { CaretRight as h } from "../../../foundations/icons/CaretRight.js";
import { useLocalisation as f } from "../../../utils/hooks/useLocalisation.js";
const C = ({ displayMonth: a }) => {
  const { goToMonth: i, nextMonth: r, previousMonth: t } = l(), { formatDate: n } = f();
  return /* @__PURE__ */ m(s, { children: [
    /* @__PURE__ */ o(
      e,
      {
        ariaLabel: "Previous month",
        disabled: !t,
        onClick: () => {
          t && i(t);
        },
        children: /* @__PURE__ */ o(p, {})
      }
    ),
    /* @__PURE__ */ o(c, { role: "heading", "aria-live": "polite", children: n(a, "LLLL y") }),
    /* @__PURE__ */ o(e, { ariaLabel: "Next month", disabled: !r, onClick: () => r && i(r), children: /* @__PURE__ */ o(h, {}) })
  ] });
};
export {
  C as DatePickerNav
};
//# sourceMappingURL=DatePickerNav.js.map
